var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isEditingLayer)?_c('div',{staticClass:"editing-layer-indicator"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }